import { render, staticRenderFns } from "./SelectCertificateModalBody.vue?vue&type=template&id=47f8044c&scoped=true&"
import script from "./SelectCertificateModalBody.vue?vue&type=script&lang=js&"
export * from "./SelectCertificateModalBody.vue?vue&type=script&lang=js&"
import style0 from "./SelectCertificateModalBody.vue?vue&type=style&index=0&id=47f8044c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f8044c",
  null
  
)

export default component.exports